// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_container__26Y3P","mail":"footer_mail__-Zd_K"};